import { useUserStore } from '@/stores/userStore'
import ErrorAlert from '@/components/ErrorAlert/ErrorAlert.vue'
import { computed, onMounted } from 'vue'
import logo from '@/assets/logo.png'

export default {
  name: 'App',
  components: { ErrorAlert },
  setup() {
    const userStore = useUserStore()
    const avatar = userStore.getUserAvatarUrl
    const user = computed(() => {
      return userStore.user
    })
    const loggedIn = computed(() => {
      return !!user.value._id
    })

    onMounted(() => {
      if (!loggedIn.value) {
        const url = new URL(window.location.href)
        if (url.pathname !== '/login') window.location.href = '/login'
      }
    })

    function getPageName() {
      const url = new URL(window.location.href)?.pathname
      if (url === '/') return 'Dashboard'
      if (url === '/recipes') return 'Rezepte'
      if (url === '/settings') return 'Einstellungen'
    }
    async function logout() {
      await userStore.logout()
    }

    function isCurrentPath(path) {
      const currentPath = new URL(window.location.href)?.pathname
      if (currentPath && currentPath.includes(path)) return true
      if (currentPath === '/' && path === 'home') return true
      return false
    }

    return { user, loggedIn, avatar, logo, logout, getPageName, isCurrentPath }
  },
}
